module.exports = __webpack_public_path__ + "img/BesideHead.a4e08a5f.svg";